import { render, staticRenderFns } from "./CreateCustomer.vue?vue&type=template&id=a9ad1c50"
import script from "./CreateCustomer.vue?vue&type=script&lang=js"
export * from "./CreateCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports